import React from 'react';
import { useI18n } from '../../../../contexts/I18nContext';
import './Veo2HowTo.scss';

const Veo2HowTo = () => {
  const { t } = useI18n();
  const steps = t('videoGeneration.veo.howto.steps');
  return (
    <section className="veo2-howto">
      <div className="veo2-howto__inner">
        <h2 className="veo2-howto__title">{t('videoGeneration.veo.howto.title')}</h2>
        <p className="veo2-howto__subtitle">{t('videoGeneration.veo.howto.subtitle')}</p>
        <div className="veo2-howto__grid">
          <article className="veo2-step">
            <div className="veo2-step__badge">{steps[0].num}</div>
            <h3>{steps[0].title}</h3>
            <p>{steps[0].body}</p>
          </article>
          <div className="veo2-howto__arrow" />
          <article className="veo2-step">
            <div className="veo2-step__badge">{steps[1].num}</div>
            <h3>{steps[1].title}</h3>
            <p>{steps[1].body}</p>
          </article>
          <div className="veo2-howto__arrow" />
          <article className="veo2-step">
            <div className="veo2-step__badge">{steps[2].num}</div>
            <h3>{steps[2].title}</h3>
            <p>{steps[2].body}</p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Veo2HowTo;